import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {colors, spacing} from "../theme";
import {withStopPropagation} from "../utils";
import {Button} from "./Button";
import {Container} from "./Container";
import {Text} from "./Text";

type ToggleButtonVariant = "ghost" | "text";

type ToggleButtonProps = {
  expanded: boolean;
  onClick: () => void;
  expandedLabel?: string;
  collapsedLabel?: string;
  variant?: ToggleButtonVariant;
  fullWidth?: boolean;
};

const Icon = ({expanded}: {expanded: boolean}) =>
  expanded ? (
    <ExpandLessIcon sx={{fontSize: 16, color: colors.grey[800]}} />
  ) : (
    <ExpandMoreIcon sx={{fontSize: 16, color: colors.grey[800]}} />
  );

export const ToggleButton = ({
  expanded,
  onClick,
  expandedLabel = "Hide details",
  collapsedLabel = "More details",
  variant = "ghost",
  fullWidth = false,
}: ToggleButtonProps) => {
  if (variant === "text") {
    return (
      <Container row gap={1} onClick={withStopPropagation(onClick)} sx={{alignItems: "center", cursor: "pointer"}}>
        <Text variant="body-semibold" color={colors.grey[800]}>
          {expanded ? expandedLabel : collapsedLabel}
        </Text>
        <Icon expanded={expanded} />
      </Container>
    );
  }

  return (
    <Button
      fullWidth={fullWidth}
      variant={variant}
      size="small"
      animateIcon={false}
      onClick={withStopPropagation(onClick)}
      endIcon={<Icon expanded={expanded} />}
      sx={{fontWeight: 500, padding: spacing[3]}}
    >
      {expanded ? expandedLabel : collapsedLabel}
    </Button>
  );
};
